unit uUsuarios;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, WEBLib.CDS, WEBLib.REST,
  Vcl.Controls, Vcl.Grids, WEBLib.DBCtrls, WEBLib.JSON,
  WEBLib.StdCtrls, System.Variants, Variants,
  WEBLib.ExtCtrls, Vcl.Imaging.jpeg,
  WEBLib.ComCtrls, WEBLib.Buttons, Vcl.StdCtrls, Vcl.Graphics,
  Vcl.Imaging.pngimage, System.DateUtils;

type
  TFUsuarios = class(TForm)
    CUsuarios: TClientConnection;
    TUsuarios: TClientDataSet;
    DsUsuarios: TDataSource;
    WebLabel5: TLabel;
    WebDBEdit5: TDBEdit;
    WebLabel1: TLabel;
    WebDBEdit1: TDBEdit;
    WebLabel2: TLabel;
    WebDBEdit2: TDBEdit;
    WebLabel3: TLabel;
    WebDBEdit3: TDBEdit;
    WebLabel4: TLabel;
    WebDBEdit4: TDBEdit;
    WebDBGrid1: TDBGrid;
    WebSpeedButton7: TSpeedButton;
    WebSpeedButton4: TSpeedButton;
    WebSpeedButton2: TSpeedButton;
    WebSpeedButton1: TSpeedButton;
    WebSpeedButton10: TSpeedButton;
    WebHttpRequest1: THttpRequest;
    WebSpeedButton3: TSpeedButton;
    procedure WebFormCreate(Sender: TObject);
    procedure WebSpeedButton1Click(Sender: TObject);
    procedure WebSpeedButton2Click(Sender: TObject);
    procedure WebSpeedButton7Click(Sender: TObject);
    procedure CUsuariosAfterConnect(Sender: TObject);
    procedure WebSpeedButton4Click(Sender: TObject);
    procedure WebSpeedButton10Click(Sender: TObject);
    procedure WebSpeedButton3Click(Sender: TObject);
  private
    { Private declarations }
    procedure ActivaCaptura;
    procedure DesactivaCaptura;
    procedure DesactivaTodo;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;
  type
  TProcedureRef = reference to procedure;

var
  FUsuarios: TFUsuarios;
  Bandera: String;

implementation

{$R *.dfm}

procedure SleepAsync(Milliseconds: Integer; AProc: TProcedureRef);
begin
  asm
    setTimeout(function() {
    AProc();
     }, Milliseconds);
  end;
end;

procedure TFUsuarios.WebFormCreate(Sender: TObject);
begin
CUsuarios.Command := httpGET;
CUsuarios.URI := 'http://207.244.241.82:9000/Usuarios?User='+'a4f9c1d27b4e4f8a9c6d2e5b7a1c9d3f8b2e6a1d4c7f9e3b5a8c2d6e1f4a7b9c';
CUsuarios.Active := True;
DesactivaTODO;
end;

procedure TFUsuarios.WebSpeedButton10Click(Sender: TObject);
begin
FUsuarios.Hide;
end;

procedure TFUsuarios.WebSpeedButton1Click(Sender: TObject);
begin
TUsuarios.Insert;
Bandera := 'Insertar';
ActivaCaptura;
end;

procedure TFUsuarios.WebSpeedButton2Click(Sender: TObject);
begin
TUsuarios.Edit;
Bandera := 'Edita';
ActivaCaptura;
end;

procedure TFUsuarios.WebSpeedButton3Click(Sender: TObject);
var
  Data: TJSONObject;
begin
  Data := TJSONObject.Create;
  try
    Data.AddPair('Numero', TUsuarios.FieldByName('Numero').AsString);

    WebHttpRequest1.URL := 'http://207.244.241.82:9000/Usuarios';
    WebHttpRequest1.Headers.Clear;
    WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
    WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
    WebHttpRequest1.Command := httpDELETE;
    WebHttpRequest1.PostData := Data.ToJSON;
    WebHttpRequest1.Execute;
  finally
    Data.Free;
  end;
  SleepAsync(300,
    procedure
    begin
      TUsuarios.Refresh;
    end);
end;

procedure TFUsuarios.WebSpeedButton4Click(Sender: TObject);
begin
TUsuarios.Cancel;
DesactivaCaptura;
end;

procedure TFUsuarios.WebSpeedButton7Click(Sender: TObject);
var
  Data: TJSONObject;
begin
TUsuarios.Post;
  if Bandera = 'Insertar' then
  begin
    Data := TJSONObject.Create;
    try
      Data.AddPair('Numero', TUsuarios.FieldByName('Numero').AsString);
      Data.AddPair('Nombre', TUsuarios.FieldByName('Nombre').AsString);
      Data.AddPair('Nivel', TUsuarios.FieldByName('Nivel').AsString);
      Data.AddPair('User', TUsuarios.FieldByName('User').AsString);
      Data.AddPair('Pass', TUsuarios.FieldByName('Pass').AsString);

      WebHttpRequest1.URL := 'http://207.244.241.82:9000/Usuarios';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPOST;
      WebHttpRequest1.PostData := Data.ToJSON;

      WebHttpRequest1.Execute;

    finally
      Data.Free;
    end;
    SleepAsync(300,
      procedure
      begin
        TUsuarios.Refresh;
      end);
  end;
  if Bandera = 'Edita' then
  begin
    Data := TJSONObject.Create;
    try
      Data.AddPair('Numero', TUsuarios.FieldByName('Numero').AsString);
      Data.AddPair('Nombre', TUsuarios.FieldByName('Nombre').AsString);
      Data.AddPair('Nivel', TUsuarios.FieldByName('Nivel').AsString);
      Data.AddPair('User', TUsuarios.FieldByName('User').AsString);
      Data.AddPair('Pass', TUsuarios.FieldByName('Pass').AsString);

      WebHttpRequest1.URL := 'http://207.244.241.82:9000/Usuarios';
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.AddPair('Content-Type', 'application/json');
      WebHttpRequest1.Headers.AddPair('Accept', 'application/json');
      WebHttpRequest1.Command := httpPUT;
      WebHttpRequest1.PostData := Data.ToJSON;

      WebHttpRequest1.Execute;

    finally
      Data.Free;
    end;
    SleepAsync(300,
      procedure
      begin
        TUsuarios.Refresh;
      end);
  end;
Bandera:='';
DesactivaCaptura;
end;

procedure TFUsuarios.DesactivaTodo;
begin
WebDBEdit1.Enabled:=False;
WebDBEdit2.Enabled:=False;
WebDBEdit3.Enabled:=False;
WebDBEdit4.Enabled:=False;
WebDBEdit5.Enabled:=False;
WebSpeedButton1.Enabled:=False;
WebSpeedButton2.Enabled:=False;

WebSpeedButton4.Visible:=False;
WebSpeedButton7.Visible:=False;
end;

procedure TFUsuarios.CUsuariosAfterConnect(Sender: TObject);
begin
DesactivaCaptura;
end;

procedure TFUsuarios.DesactivaCaptura;
begin
WebDBEdit1.Enabled:=False;
WebDBEdit2.Enabled:=False;
WebDBEdit3.Enabled:=False;
WebDBEdit4.Enabled:=False;
WebDBEdit5.Enabled:=False;
WebSpeedButton1.Enabled:=True;
WebSpeedButton2.Enabled:=True;

WebSpeedButton4.Visible:=False;
WebSpeedButton7.Visible:=False;
end;

procedure TFUsuarios.ActivaCaptura;
begin
WebDBEdit1.Enabled:=True;
WebDBEdit2.Enabled:=True;
WebDBEdit3.Enabled:=True;
WebDBEdit4.Enabled:=True;
WebDBEdit5.Enabled:=True;
WebSpeedButton1.Enabled:=False;
WebSpeedButton2.Enabled:=False;

WebSpeedButton4.Visible:=True;
WebSpeedButton7.Visible:=True;
end;


procedure TFUsuarios.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel5 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebDBEdit5 := TDBEdit.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDBEdit4 := TDBEdit.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  WebSpeedButton7 := TSpeedButton.Create(Self);
  WebSpeedButton4 := TSpeedButton.Create(Self);
  WebSpeedButton2 := TSpeedButton.Create(Self);
  WebSpeedButton1 := TSpeedButton.Create(Self);
  WebSpeedButton10 := TSpeedButton.Create(Self);
  WebSpeedButton3 := TSpeedButton.Create(Self);
  CUsuarios := TClientConnection.Create(Self);
  TUsuarios := TClientDataSet.Create(Self);
  DsUsuarios := TDataSource.Create(Self);
  WebHttpRequest1 := THttpRequest.Create(Self);

  WebLabel5.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebDBEdit5.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDBEdit4.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  WebSpeedButton7.BeforeLoadDFMValues;
  WebSpeedButton4.BeforeLoadDFMValues;
  WebSpeedButton2.BeforeLoadDFMValues;
  WebSpeedButton1.BeforeLoadDFMValues;
  WebSpeedButton10.BeforeLoadDFMValues;
  WebSpeedButton3.BeforeLoadDFMValues;
  CUsuarios.BeforeLoadDFMValues;
  TUsuarios.BeforeLoadDFMValues;
  DsUsuarios.BeforeLoadDFMValues;
  WebHttpRequest1.BeforeLoadDFMValues;
  try
    Name := 'FUsuarios';
    Width := 1260;
    Height := 669;
    Caption := 'DsUsuarios';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 40;
    WebLabel5.Top := 102;
    WebLabel5.Width := 37;
    WebLabel5.Height := 13;
    WebLabel5.Caption := 'N'#250'mero';
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 40;
    WebLabel1.Top := 149;
    WebLabel1.Width := 37;
    WebLabel1.Height := 13;
    WebLabel1.Caption := 'Nombre';
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 40;
    WebLabel2.Top := 196;
    WebLabel2.Width := 23;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Nivel';
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 40;
    WebLabel3.Top := 243;
    WebLabel3.Width := 56;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Contrase'#241'a';
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.WidthPercent := 100.000000000000000000;
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 40;
    WebLabel4.Top := 290;
    WebLabel4.Width := 36;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Usuario';
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebDBEdit5.SetParentComponent(Self);
    WebDBEdit5.Name := 'WebDBEdit5';
    WebDBEdit5.Left := 40;
    WebDBEdit5.Top := 121;
    WebDBEdit5.Width := 217;
    WebDBEdit5.Height := 22;
    WebDBEdit5.ChildOrder := 4;
    WebDBEdit5.HeightPercent := 100.000000000000000000;
    WebDBEdit5.Text := 'WebDBEdit1';
    WebDBEdit5.WidthPercent := 100.000000000000000000;
    WebDBEdit5.DataField := 'Numero';
    WebDBEdit5.DataSource := DsUsuarios;
    WebDBEdit1.SetParentComponent(Self);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 40;
    WebDBEdit1.Top := 168;
    WebDBEdit1.Width := 217;
    WebDBEdit1.Height := 22;
    WebDBEdit1.ChildOrder := 4;
    WebDBEdit1.HeightPercent := 100.000000000000000000;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.WidthPercent := 100.000000000000000000;
    WebDBEdit1.DataField := 'Nombre';
    WebDBEdit1.DataSource := DsUsuarios;
    WebDBEdit2.SetParentComponent(Self);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 40;
    WebDBEdit2.Top := 215;
    WebDBEdit2.Width := 217;
    WebDBEdit2.Height := 22;
    WebDBEdit2.ChildOrder := 4;
    WebDBEdit2.HeightPercent := 100.000000000000000000;
    WebDBEdit2.Text := 'WebDBEdit1';
    WebDBEdit2.WidthPercent := 100.000000000000000000;
    WebDBEdit2.DataField := 'Nivel';
    WebDBEdit2.DataSource := DsUsuarios;
    WebDBEdit3.SetParentComponent(Self);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 40;
    WebDBEdit3.Top := 262;
    WebDBEdit3.Width := 217;
    WebDBEdit3.Height := 22;
    WebDBEdit3.ChildOrder := 4;
    WebDBEdit3.HeightPercent := 100.000000000000000000;
    WebDBEdit3.Text := 'WebDBEdit1';
    WebDBEdit3.WidthPercent := 100.000000000000000000;
    WebDBEdit3.DataField := 'Pass';
    WebDBEdit3.DataSource := DsUsuarios;
    WebDBEdit4.SetParentComponent(Self);
    WebDBEdit4.Name := 'WebDBEdit4';
    WebDBEdit4.Left := 40;
    WebDBEdit4.Top := 309;
    WebDBEdit4.Width := 217;
    WebDBEdit4.Height := 22;
    WebDBEdit4.ChildOrder := 4;
    WebDBEdit4.HeightPercent := 100.000000000000000000;
    WebDBEdit4.Text := 'WebDBEdit1';
    WebDBEdit4.WidthPercent := 100.000000000000000000;
    WebDBEdit4.DataField := 'User';
    WebDBEdit4.DataSource := DsUsuarios;
    WebDBGrid1.SetParentComponent(Self);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 305;
    WebDBGrid1.Top := 102;
    WebDBGrid1.Width := 512;
    WebDBGrid1.Height := 523;
    WebDBGrid1.Columns.Clear;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Numero';
      Title := 'N'#250'mero';
      Width := 150;
    end;
    with WebDBGrid1.Columns.Add do
    begin
      DataField := 'Nombre';
      Title := 'Nombre';
      Width := 300;
    end;
    WebDBGrid1.DataSource := DsUsuarios;
    WebDBGrid1.FixedCols := 1;
    WebDBGrid1.TabOrder := 5;
    WebDBGrid1.HeightPercent := 100.000000000000000000;
    WebDBGrid1.WidthPercent := 100.000000000000000000;
    WebDBGrid1.ColWidths[0] := 24;
    WebDBGrid1.ColWidths[1] := 150;
    WebDBGrid1.ColWidths[2] := 300;
    WebSpeedButton7.SetParentComponent(Self);
    WebSpeedButton7.Name := 'WebSpeedButton7';
    WebSpeedButton7.Left := 415;
    WebSpeedButton7.Top := 51;
    WebSpeedButton7.Width := 41;
    WebSpeedButton7.Height := 33;
    WebSpeedButton7.Color := clNone;
    WebSpeedButton7.Glyph.LoadFromFile('uUsuarios.WebSpeedButton7.Glyph.png');
    WebSpeedButton7.HeightPercent := 100.000000000000000000;
    WebSpeedButton7.Layout := blGlyphTop;
    WebSpeedButton7.Visible := False;
    WebSpeedButton7.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton7, Self, 'OnClick', 'WebSpeedButton7Click');
    WebSpeedButton4.SetParentComponent(Self);
    WebSpeedButton4.Name := 'WebSpeedButton4';
    WebSpeedButton4.Left := 462;
    WebSpeedButton4.Top := 51;
    WebSpeedButton4.Width := 41;
    WebSpeedButton4.Height := 33;
    WebSpeedButton4.Color := clNone;
    WebSpeedButton4.Glyph.LoadFromFile('uUsuarios.WebSpeedButton4.Glyph.png');
    WebSpeedButton4.HeightPercent := 100.000000000000000000;
    WebSpeedButton4.Layout := blGlyphTop;
    WebSpeedButton4.Visible := False;
    WebSpeedButton4.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton4, Self, 'OnClick', 'WebSpeedButton4Click');
    WebSpeedButton2.SetParentComponent(Self);
    WebSpeedButton2.Name := 'WebSpeedButton2';
    WebSpeedButton2.Left := 165;
    WebSpeedButton2.Top := 40;
    WebSpeedButton2.Width := 119;
    WebSpeedButton2.Height := 44;
    WebSpeedButton2.Caption := 'Editar';
    WebSpeedButton2.Color := clNone;
    WebSpeedButton2.Glyph.LoadFromFile('uUsuarios.WebSpeedButton2.Glyph.png');
    WebSpeedButton2.HeightPercent := 100.000000000000000000;
    WebSpeedButton2.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton2, Self, 'OnClick', 'WebSpeedButton2Click');
    WebSpeedButton1.SetParentComponent(Self);
    WebSpeedButton1.Name := 'WebSpeedButton1';
    WebSpeedButton1.Left := 40;
    WebSpeedButton1.Top := 40;
    WebSpeedButton1.Width := 119;
    WebSpeedButton1.Height := 44;
    WebSpeedButton1.Caption := 'Agregar';
    WebSpeedButton1.Color := clNone;
    WebSpeedButton1.Glyph.LoadFromFile('uUsuarios.WebSpeedButton1.Glyph.png');
    WebSpeedButton1.HeightPercent := 100.000000000000000000;
    WebSpeedButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton1, Self, 'OnClick', 'WebSpeedButton1Click');
    WebSpeedButton10.SetParentComponent(Self);
    WebSpeedButton10.Name := 'WebSpeedButton10';
    WebSpeedButton10.Left := 1163;
    WebSpeedButton10.Top := 17;
    WebSpeedButton10.Width := 81;
    WebSpeedButton10.Height := 44;
    WebSpeedButton10.Caption := 'Salir';
    WebSpeedButton10.Color := clNone;
    WebSpeedButton10.Glyph.LoadFromFile('uUsuarios.WebSpeedButton10.Glyph.png');
    WebSpeedButton10.HeightPercent := 100.000000000000000000;
    WebSpeedButton10.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton10, Self, 'OnClick', 'WebSpeedButton10Click');
    WebSpeedButton3.SetParentComponent(Self);
    WebSpeedButton3.Name := 'WebSpeedButton3';
    WebSpeedButton3.Left := 290;
    WebSpeedButton3.Top := 40;
    WebSpeedButton3.Width := 119;
    WebSpeedButton3.Height := 44;
    WebSpeedButton3.Caption := 'Borrar';
    WebSpeedButton3.Color := clNone;
    WebSpeedButton3.Glyph.LoadFromFile('uUsuarios.WebSpeedButton3.Glyph.png');
    WebSpeedButton3.HeightPercent := 100.000000000000000000;
    WebSpeedButton3.WidthPercent := 100.000000000000000000;
    SetEvent(WebSpeedButton3, Self, 'OnClick', 'WebSpeedButton3Click');
    CUsuarios.SetParentComponent(Self);
    CUsuarios.Name := 'CUsuarios';
    CUsuarios.Active := False;
    CUsuarios.AfterConnect := CUsuariosAfterConnect;
    CUsuarios.Left := 608;
    CUsuarios.Top := 32;
    TUsuarios.SetParentComponent(Self);
    TUsuarios.Name := 'TUsuarios';
    TUsuarios.Connection := CUsuarios;
    TUsuarios.Left := 663;
    TUsuarios.Top := 32;
    DsUsuarios.SetParentComponent(Self);
    DsUsuarios.Name := 'DsUsuarios';
    DsUsuarios.DataSet := TUsuarios;
    DsUsuarios.Left := 719;
    DsUsuarios.Top := 32;
    WebHttpRequest1.SetParentComponent(Self);
    WebHttpRequest1.Name := 'WebHttpRequest1';
    WebHttpRequest1.Headers.BeginUpdate;
    try
      WebHttpRequest1.Headers.Clear;
      WebHttpRequest1.Headers.Add('Cache-Control=no-cache, no-store, must-revalidate');
    finally
      WebHttpRequest1.Headers.EndUpdate;
    end;
    WebHttpRequest1.Left := 512;
    WebHttpRequest1.Top := 32;
  finally
    WebLabel5.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebDBEdit5.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDBEdit4.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    WebSpeedButton7.AfterLoadDFMValues;
    WebSpeedButton4.AfterLoadDFMValues;
    WebSpeedButton2.AfterLoadDFMValues;
    WebSpeedButton1.AfterLoadDFMValues;
    WebSpeedButton10.AfterLoadDFMValues;
    WebSpeedButton3.AfterLoadDFMValues;
    CUsuarios.AfterLoadDFMValues;
    TUsuarios.AfterLoadDFMValues;
    DsUsuarios.AfterLoadDFMValues;
    WebHttpRequest1.AfterLoadDFMValues;
  end;
end;

end.
